import { Accessor, ZValidate } from "IZOX/STATIC";

class Password {

  static CheckIfErrors(formValue, accessor = "password"){
    let errors = [];

    let password = Accessor.Get(formValue, accessor);

    if(password?.length < 8){
      errors.push({
        EN: "length cannot be shorter than 8",
        TC: "長度不能短於8位"
      });
    }

    if(!ZValidate.CheckAllFields(formValue, [accessor], ["atLeastOneSpecialChar"])){
      errors.push(ZValidate.ErrorMsg.atLeastOneSpecialChar);
    }

    if(!ZValidate.CheckAllFields(formValue, [accessor], ["atLeastOneLowerCase"])){
      errors.push(ZValidate.ErrorMsg.atLeastOneLowerCase);
    }

    if(!ZValidate.CheckAllFields(formValue, [accessor], ["atLeastOneNumeric"])){
      errors.push(ZValidate.ErrorMsg.atLeastOneNumeric);
    }

    if(!ZValidate.CheckAllFields(formValue, [accessor], ["atLeastOneUpperCase"])){
      errors.push(ZValidate.ErrorMsg.atLeastOneUpperCase);
    }

    if(!ZValidate.CheckLength(formValue, [accessor], 8, 15)){
      errors.push({
        EN: "Total length must be in the range [8-15]",
        TC: "總長度必須在 [8-15] 範圍內"
      });
    }

    return errors;
  }

}

export default Password;